// 反馈属于平台域，始终走正式平台入口，避免旧 /v1 路由转发到其他服务。
export const USER_FEEDBACK_API = { baseURL: '/api/platform/v1' } as const;
